import { Rating } from '@sortlist-frontend/design-system/legacy';
import { Trans } from '@sortlist-frontend/translation/ssr';

import { SectionsDetails } from '_features/AgencyProfile/components/SectionsDetails';
import * as S from '_features/AgencyProfile/components/ServicesPanel/styles';
import type { Section } from '_features/AgencyProfile/utils';

import type { ServiceReviewNode } from './types';

interface Props {
  serviceName: string;
  reviews: ServiceReviewNode[];
  className?: string;
  handleActivePanel: (value: Section | undefined) => void;
}

export const ServiceReviews = (props: Props) => {
  const { className, serviceName, reviews, handleActivePanel } = props;
  const maxNumberOfCardsDisplayed = 4;

  return (
    <section className={`${className} p-4 layout-column`}>
      <header className="p-2">
        <Trans i18nKey={'agency:profile.services.reviewsTitle'} count={reviews.length}>
          <b>Reviews</b> in {{ serviceName }} ({{ count: reviews.length }})
        </Trans>
      </header>
      <div className="flex-1 layout-row p-2">
        <div className="flex-1 layout-row layout-wrap">
          {reviews.slice(0, maxNumberOfCardsDisplayed).map((review, index) => (
            <div
              key={`${review.userFullName}-${index}`}
              className="pr-2 pb-2 flex-xs-100 flex-sm-33 flex-gt-sm-20 layout-row">
              <div className="shadow-2 p-2 flex-1 rounded-sm bg-neutral-50 layout-column">
                <span className="small bold mb-1 text-truncate">{review.userFullName}</span>
                <div className="layout-row">
                  {review.rating != null ? <Rating rate={review.rating * 5} size={14} /> : null}
                </div>
              </div>
            </div>
          ))}
          {reviews.length > maxNumberOfCardsDisplayed && (
            <div className="pr-2 pb-2 flex-xs-100 flex-sm-33 flex-gt-sm-20">
              <S.ItemExpand
                size="lg"
                buttonStyle="secondary"
                className="layout-fill bg-secondary-200 text-secondary-500"
                label={`+${reviews.length - maxNumberOfCardsDisplayed}`}
                onClick={() => handleActivePanel(SectionsDetails?.find((section) => section.id === 'reviews'))}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
